import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsFromPaybackMigrationExist } from '../../selectors/myHome';
import { selectIsWebview } from '../../selectors/page';
import { MyHomeBannerContainer } from '../MyHomeBannerContainer';

/**
 * Стики баннер в мобильной версии сайта
 *   если есть миграция из оценки в мой дом - показываем соответствующий баннер
 */
export const TopMobileBanner: React.FC = () => {
  const isWebview = useSelector(selectIsWebview);
  const isFromPaybackMigrationExist = useSelector(selectIsFromPaybackMigrationExist);

  if (isWebview && isFromPaybackMigrationExist) {
    return <MyHomeBannerContainer />;
  }

  return null;
};

TopMobileBanner.displayName = 'TopMobileBanner';
